import React from 'react'
import { Route, Redirect } from 'react-router-dom'
// import { useSelector } from "react-redux";

const ProtectedRoute = ({ redirectTo = '/', component: Component, ...rest }) => {
  const token = localStorage.getItem('token')

  return (
    <Route
      {...rest}
      render={(props) =>
        token ? <Component {...props} /> : <Redirect to={{ pathname: redirectTo }} />
      }
    />
  )
}

export default ProtectedRoute
